import * as React from "react";
function SvgViewFile(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <g clipPath="url(#view-file_svg__clip0_1347_7035)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22 5.68v11.745a1.669 1.669 0 01-1.665 1.667h-7.918a.393.393 0 01-.238-.105l-.382-.382a.22.22 0 01-.01-.193 5.75 5.75 0 00.35-.846.2.2 0 01.191-.14h7.59a.416.416 0 00.417-.417V5.853a.418.418 0 00-.122-.294l-1.766-1.77a.416.416 0 00-.294-.121H9.097a.416.416 0 00-.416.417v5.94a.203.203 0 01-.271.188 5.756 5.756 0 00-1.21-.258.201.201 0 01-.184-.2V3.667A1.669 1.669 0 018.68 2h9.645c.441 0 .864.176 1.177.489l2.01 2.012c.311.313.487.737.487 1.18zM11.394 21.766l-2.086-2.09a.2.2 0 00-.253-.024 4.585 4.585 0 01-6.047-1.004 4.603 4.603 0 01.34-6.13 4.588 4.588 0 017.773 2.51 4.605 4.605 0 01-.66 3.22.2.2 0 00.024.25l2.087 2.089A.835.835 0 0111.98 22a.832.832 0 01-.586-.234zm-6.413-3.554a2.91 2.91 0 004.532-2.427 2.922 2.922 0 00-1.799-2.696 2.91 2.91 0 00-3.175.633 2.92 2.92 0 00.442 4.49zM18.656 8.1a.75.75 0 10-1.06-1.06l-2.27 2.27-.913-.913a.75.75 0 00-1.061 0l-2.64 2.64a.75.75 0 001.061 1.06l2.11-2.109.912.913a.75.75 0 001.06 0L18.657 8.1z"
                    fill="currentcolor"
                />
            </g>
            <defs>
                <clipPath id="view-file_svg__clip0_1347_7035">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgViewFile);
export default ForwardRef;
